import React, { useRef } from 'react';
import AwardsList, { AwardItem } from '../ui/AwardsList';
import gsap from "gsap";
import { useGSAP } from '@gsap/react';

    interface AwardsProps {
    title: string;
    text: string;
    items: AwardItem[];
    }

const Awards = ({title, text, items}: AwardsProps) => {

    const sectionRef = useRef(null);      
    const containerRef = useRef(null)
    const titleRef = useRef(null);
    const textRef = useRef(null);

  useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {


     gsap.fromTo(containerRef.current, {
        y: '13rem'
      },
          {
        y: 0,
        ease: "none",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top bottom", 
          end: "top 60%",  
          scrub: 0.1,  
        },
      });


      gsap.fromTo(titleRef.current, { opacity: 0 }, {
        opacity: 1,

        duration: 1,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 60%",
        },
      });

      gsap.fromTo(textRef.current, { opacity: 0}, {
        opacity: 1,
        duration: 1,
        delay: 0.2,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 60%",
        },
      });

    });

    return () => mm.revert();
  }, {scope: sectionRef});


    return (
        <section ref={sectionRef} className={'pt-[4rem] container-max md:pt-[6rem] lg:pt-[8rem] xl:pt-[10rem] pb-[2.4rem] md:pb-[4.8rem] lg:pb-[13rem] xl:pb-[15rem] container-padding'}>
          <div ref={containerRef} className='w-full'>


            <div className='container-grid flex-col lg:flex lg:text-center lg:flex-col lg:items-center mb-[2.4rem] lg:mb-[2.4rem]'>
                <h2 ref={titleRef} className='mb-[2rem] w-full lg:mb-[3.2rem] xl:mb-[3.6rem] md:col-span-2'>{title}</h2>
                <p ref={textRef} className='text-1 md:col-span-2 lg:max-w-[48rem] xl:max-w-[57rem] md:col-start-4'>{text}</p>
            </div>
            <AwardsList items={items}/>
          </div>
        </section>
    );
};

export default Awards;